import { connect } from 'react-redux';
import App, {
    AppPropsFromState
} from '../components/App';
import {
    RootState,
    selectErrorMessage,
    selectLoadingStatus,
    selectLoggedinUser,
} from '../store';

export const mapStateToProps = (state: RootState): AppPropsFromState => {
    return {
        loading: selectLoadingStatus(state),
        loggedInUser: selectLoggedinUser(state),
        errorMessage: selectErrorMessage(state)
    }
};

export default connect(mapStateToProps)(App);
